/** The element the page template renders and `init.tsx` mounts React into; everything the page shows lives inside it. */
export const PAGE_ROOT_ID = 'rootApp';
